export const TRANSLATIONS = {
    EN: {
        GLOBAL: {
            RECOMMENDED: 'Recommended',
            CONTINUE: 'Continue',
            COMPLETED: 'Completed',
            APPROVED: 'Approved',
            SERVICE_PROVIDERS: 'Service Providers',
            NO_RETAINER: 'No retainer',
            CONTRACTS: 'Contracts',
            TEMPLATES: 'Templates',
            ALL: 'All',
            START_NEW_JOB: 'Start new job',
            DASHBOARD: 'Dashboard',
            SHORTCUT_TO: 'Shortcut to',
            JOBS: 'Jobs',
            TASKS: 'Tasks',
            RISK_WORDS: 'Risk Words',
            IN_USE: 'In use',
            THIS_YEAR: 'This year',
            CURRENT_YEAR: 'Current year',
            CURRENT_MONTH: 'Current month',
            TOTAL_NUMBER: 'Total number',
            LANGUAGE: 'Language',
            ENTITY: 'Entity',
            ENTITIES: 'Entities',
            INCORPORATIONS: 'Incorporations',
            INVOICES: 'Invoices',
            APPLICATIONS: 'Applications',
            RUNNING_JOBS: 'Running jobs',
            COMPLETED_JOBS: 'completed jobs',
            FIRM24: 'FIRM24',
            MANDATORY: 'Mandatory',
            OPTIONAL: 'Optional',
            REQUEST_UBO_REGISTRATION: 'Requested UBO Registration',
            REJECT_JOB: 'Reject the job',
            REASON_REJECT_THE_JOB: 'Give the service provider a reason for the rejection',
            PAYMENT: 'Payment',
            PAY_VALUE: 'Pay {value}',
            CONTINUE_TO_PAYMENT: 'Continue to payment',
            EXTRA_PAYMENT: 'Extra payment',
            FIXED_FEE: 'Fixed fee',
            QUOTE: 'Quote',
            DATE: 'Date',
            TIME: 'Time',
            FROM: 'From',
            UNTIL: 'Until',
            MISSING_DOCUMENT: 'Missing document',
            PRODUCT: 'Product',
            REPLACE: 'Replace',
            DELETE: 'Delete',
            PREVIEW: 'Preview',
            TITLE: 'Title',
            SLUG: 'Slug',
            RECURRENCE: 'Recurrence',
            CONTENT: 'Content',
            DOCUMENT: 'Document',
            DIRECTOR: 'Director',
            SHAREHOLDER: 'Shareholder',
            FUNCTION: 'Function',
            BV: 'BV',
            FOUNDATION: 'Foundation',
            TRUE: 'Yes',
            FALSE: 'No',
            CONFIRM: 'Confirm',
            ALERT: 'Alert',
            INFORM: 'Inform',
            TYPE: 'Type',
            NO_DOCUMENTS_AVAILABLE: 'No documents available',
            NO_DATA_AVAILABLE: 'No data available',
            NO_MESSAGE_AVAILABLE: 'No messages yet.',
            NO_DESCRIPTION_AVAILABLE: 'No description yet.',
            LABEL: 'Label',
            STARTING_DATE: 'Starting date',
            LOGOUT: 'Logout',
            NEXT_BILLING: 'Next billing',
            NOT_YET_AVAILABLE: 'n/a',
            NETHERLANDS: 'Netherlands',
            DUTCH: 'Nederlands',
            ENGLISH: 'English',
            PAGE_NOT_FOUND: 'Oops, this page does not exist',
            MODULES: 'Modules',
            ROLE: 'Role',
            PERMISSIONS: 'Permissions',
            ITEMS_PER_PAGE: 'Items per page',
            SEND_MESSAGE: 'Send message [Ctrl+Enter]',
            ADD_ORGANIZATION: 'Add Organization',
            NEW_MESSAGE: 'New message',
            MESSAGES: 'Messages',
            SKIP: 'Skip',
            TIMELINE: 'Timeline',
            DOWNLOAD: 'Download',
            DOWNLOAD_PDF: 'Download PDF',
            DOWNLOAD_FILE: 'Download file',
            DOWNLOAD_FILES: 'Download Files',
            LAST_UPDATE: 'Last update',
            CREATED: 'Created',
            UPDATE: 'Update',
            UPDATED: 'Updated',
            AMOUNT: 'Amount',
            LAST_LOGIN: 'Last login',
            PRODUCTS: 'Products',
            RISK_LEVEL: 'Risk level',
            CATEGORY: 'Category',
            ARE_YOU_SURE: 'Are you sure?',
            ARE_YOU_SURE_UPLOAD_FILES: 'Are you sure you want to upload {files}',
            ARE_YOU_SURE_GO_BACK: 'Are you sure you want to go back to {step}?',
            ARE_YOU_SURE_TO: 'Are you sure you want to: {step}?',
            ARE_YOU_SURE_DELETE: 'Are you sure you want to delete this item?',
            ARE_YOU_SURE_SKIP_STEP: 'Are you sure you want to skip this step?',
            AGREE: 'Agree',
            CANCEL: 'Cancel',
            CANCELLED: 'Cancelled',
            SAVE: 'Save',
            DUPLICATE: 'Duplicate',
            MALE: 'Male',
            FEMALE: 'Female',
            SALUTATION: 'Salutation',
            NEXT: 'Next',
            PREVIOUS: 'Previous',
            CURRENT: 'Current',
            CLOSE: 'Close',
            REMOVE: 'Remove',
            CREATE: 'Create',
            ADDRESS: 'Address',
            INCLUDED: 'Included',
            OPTIONS: 'Options',
            MEMBER: 'Member',
            MEMBERS: 'Members',
            ADD_MEMBER: 'Add member',
            UPLOAD: 'Upload',
            UPLOADED: 'Uploaded',
            SUBMIT: 'Submit',
            INFORMATION_BV: 'Information {entity}',
            ADDITIONAL_INFORMATION: 'Additional BV Information',
            SUBJECT: 'Subject',
            DETAILS: 'Details',
            OVERVIEW: 'Overview',
            ATTACHMENT: 'Attachment',
            CLEAR_ALL_NOTIFICATIONS: 'Clear all notifications',
            REMOVE_FILTERS: 'Remove filters',
            SEARCH: 'Search...',
            REQUESTER: 'Requester',
            PRICE: 'Price',
            PURCHASE_PRICE: 'Purchase price',
            SALE_PRICE: 'Sale price',
            PURCHASE_TYPE: 'Purchase type',
            DESCRIPTION: 'Description',
            REASON: 'Reason',
            URGENCY: 'Urgency',
            REFRESH: 'Refresh',
            CHAT_CLIENT: 'Chat with client',
            NOTARY: 'Notary',
            ACCOUNT: 'Account',
            SUPPORT: 'FIRM24',
            CHAT: 'Chat with {group}',
            FAST: 'Fast',
            FAST_END_OF_THE_YEAR: 'Before 1 January',
            URGENT: 'Urgent',
            URGENT_END_OF_THE_YEAR: '5 working days',
            REGULAR: 'Regular',
            REGULAR_END_OF_THE_YEAR: 'After January 1st',
            DURATION: 'Time',
            HOLDING: 'Holding',
            SKIP_PAYMENT: 'Skip payment',
            VIEW_INVOICE: 'View invoice',
            VIEW_X_INVOICE: 'View invoice {name}',
            RATING: 'Rating',
            CLICK_HERE: 'Click here',
            CONNECT_WITH: {
                DEFAULT: 'Sign up with:',
                WITH_OR: 'Or sign up with:',
                CONTINUE_OR: 'Or continue with email',
            },
            OR: 'or',
            RESET: 'Reset all changes',
            SCENARIO: 'Scenario',
            SCENARIO_TYPE: 'Scenario type',
            STATUS: 'Status',
            STATUS_TERMINATED: 'Terminated',
            STATUS_PAUSED: 'Paused',
            CONTINUE_APPLICATION: 'Continue application',
            CONTINUE_WITH: 'Continue with',
            ACTIONS: 'Actions',
            CHANGE: 'Change',
            FULLY_PAID_SHARES: 'Fully Pay Shares',
            MORE_INFO: 'More info',
            NEXT_STEP: 'Next step',
            DISTANCE: 'Distance (kilometers)',
            TOTAL_PRICE: 'Total Price',
            PSEUDO_UBO: 'Pseudo Ubo',
            ADD: 'Add',
            QUANTITY: 'Quantity',
            BATCHES: 'Batches',
            DELETE_PAYOUT: 'Delete payout',
            TOTAL: 'Total',
            IBAN: 'IBAN',
            VAT: 'VAT',
            VAT_ADDED: 'VAT (21%)',
            PROCESSING_CAPACITY: 'Processing capacity',
            ACCOUNT_MANAGER: 'Account manager',
            SUBTOTAL: 'Subtotal',
            LOADING: 'Loading...',
            RESULTS: 'Results',
            NO_RESULTS: 'No results',
            TIME_OPTIONS: {
                MORNING: 'Morning (09:00 - 12:00)',
                AFTERNOON: 'Afternoon (12:00 - 15:00)',
                LATE_AFTERNOON: 'Late afternoon (15:00 - 18:00)',
                EVENING: 'Evening (18:00 - 20:00)',
            },
            OTHERS: 'Others',
            CANCEL_ADDING: 'Cancel adding',
            ADD_NEW_ONE: 'Add another one',
            APPROVE: 'Approve',
            REJECT: 'Reject',
            DECLINE: 'Decline',
            CONFIRM_CANCELLATION: 'Confirm cancellation',
            ACCEPT: 'Accept',
            VAT_NUMBER: 'Vat number',
            CALENDLY: 'Calendly url',
            COMPLETE_JOB: 'Complete job',
            CLIENT: 'Client',
            BUSINESS: 'Business',
            VERSION: 'version',
            FOUNDER: 'founder',
            EDIT: 'Edit',
            PAY: 'Pay',
            SERVICE_PROVIDER: 'Service provider',
            TERMS_CONDITIONS_FILE_NAME: 'Terms_&_Conditions',
            UPLOAD_TERMS_CONDITIONS: 'Upload Terms & Conditions',
            LOGO: 'Logo',
            NAME: 'Name',
            EMAIL: 'Email',
            COMMENTS: 'Client comments',
            NO_COMMENTS: 'No comments',
            INVITE_CUSTOMER: 'Invite customer',
            FREE: 'FREE',
            RETAINER: 'Retainer',
            CURRENT_ACTOR: 'Current actor',
            SCHEDULE_INTERVIEW: 'Schedule an appointment',
            STEP: 'Step',
            PROCESS: 'Process',
            MISSING_NAME: 'Missing name',
            MILESTONE: 'Milestone',
            CREDIT: 'Credit',
            HOURS: 'hours',
            CHOOSE_FILE: 'Choose file',
            REFERENCE: 'Reference',
            YES: 'Yes',
            NO: 'No',
            PROCESS_LABELS: 'Process labels',
            NO_DATA: 'No data',
            UPLOAD_PLACEHOLDER: 'Drag your PDF files here or click to upload',
        },
        NAVIGATION: {
            MY_PRODUCTS: 'My products',
            COMPANY_DETAILS: 'Company details',
            PRODUCTS_AND_SERVICES: 'Products & Services',
            SHOP_DEALS: 'Deals for entrepreneurs',
            EMAILS: 'Emails',
            SUBSCRIPTIONS: 'Subscriptions',
            DASHBOARD: 'Dashboard',
            ORGANIZATIONS: 'Organizations',
            ORGANIZATION: 'Organization',
            ACCOUNTS: 'Accounts',
            ACCOUNT: 'Account',
            OVERVIEW: 'overview',
            PROCESSES: 'Processes',
            STATS: 'Stats',
            ACCOUNT_TRANSACTIONS: 'Account Transactions',
            BOOKKEEPER_TRANSACTIONS: 'Bookkeeper Transactions',
            BOOKKEEPER_LEADS: 'Bookkeeper Leads',
            BOOKKEEPING: 'Bookkeeping',
            SERVICES: 'Services',
            TRANSACTIONS: 'Transactions',
            PURCHASE: 'Purchase',
            PAYOUT: 'Payout',
            PAYOUT_BATCH: 'Payout batch',
            SALES: 'Sales',
            INVOICES: 'Invoices',
            BANKING: 'Banking',
            SALE: 'Sales',
            CREDIT: 'Credit transactions',
            PURCHASE_PAYOUT: 'Payout',
            ADD_PRODUCT_TO_PAYOUT: 'Add product to payout',
            LEADS: 'Leads',
            LOGIN: 'login',
            PROCEDURES: 'Procedures',
            NEW_PROCEDURES: 'New procedures',
            CONTRACTS: 'Contracts',
            REQUESTED_SERVICES: 'Requested services',
            REQUEST_A_SERVICE: 'Request a service',
            BILLING: 'Billing',
            UBO: 'UBO registration',
            LIQUIDATION: 'Liquidate a company',
            OTHER_SERVICES: 'Other services',
            DGA_SERVICES: 'Payroll',
            DGA_SALARY_ADMIN: 'DGA Salary Administration',
            SEARCH_SERVICE: 'Search',
            INCORPORATION_BV: 'Incorporation',
            MODIFY_BV: 'Modify your BV',
            ACCOUNTING: 'Accounting & Taxes',
            FINANCES: 'Banking',
            COMPLIANCE: 'Legal & Compliance',
            SPECIALIST: 'Get expert advice',
            ACCOUNT_SETTINGS: 'Settings',
            TASKS: 'Tasks',
            ADMIN: 'Admin',
            HOSTING: 'Hosting',
            ZEBRA_LEGAL: 'Zebra Legal',
            PAYMENT_SOLUTIONS: 'Payment solutions',
        },
        USER: {
            NAME: 'Name',
            EMAIL: 'Email',
            FIRST_NAME: 'First name',
            LAST_NAME: 'Last name',
            COMPANY_LOCATION: 'Country where your company is registered',
            FIRST_LAST_NAME: 'First and last name',
            BIRTH_DATE: 'Date of birth',
            BIRTH_COUNTRY: 'Country of birth',
            BIRTH_PLACE: 'Place of birth',
            NATIONALITY: 'Nationality',
            LANGUAGE: 'Language',
            SPEAKS_DUTCH: 'Speaks Dutch',
            SPEAKS_ENGLISH: 'Speaks English',
            SELECT_OPTION: 'Select an option',
            SELECT_COUNTRY: 'Select a country',
            SELECT_EXPIRATION_DATE: 'Select an expiration date',
            SELECT_DATE: 'Select a date',
            FILL_IN: 'Please fill in the information',
            GENDER: 'Gender',
            PHONE: 'Telephone',
            CONTACT: 'Contact person',
            SIGN_IN: 'Sign in',
            LOGIN: 'Login',
            FORGOT_PASSWORD: 'Forgot password?',
            RESET_PASSWORD: 'Reset password',
            REGISTER: 'Register',
            CREATE_YOUR_ACCOUNT: 'Create your account',
            INITIALS: 'Initial(s)',
            ENTREPRENEUR_DMS: 'Entrepreneur (DMS)',
            ENTREPRENEUR_DMS_DESCRIPTION:
                'Choose an entrepreneur when you apply for your own company. This can be a BV, but also a sole proprietorship, VOF or other legal form.',
            ADVISOR: 'Advisor',
            ADVISOR_DESCRIPTION: 'Choose for advisor when you apply for your clients. For example, you are a bookkeeper, accountant or other business advisor.',
            EXISTING_CLIENT: 'I am already a customer',
        },
        ADDRESS: {
            STREET: 'Street',
            POSTAL_CODE: 'Postal code',
            POSTALCODE: 'Postal code',
            NUMBER: 'House number',
            ADDITION: 'Addition',
            CITY: 'City',
            PROVINCE: 'Province',
            COUNTRY: 'Country',
            PLACE_RESIDENCY: 'Place of residency',
            COUNTRY_RESIDENCY: 'Country of residency',
            NAME: 'Name',
        },
        VALIDATION: {
            THIS_FIELD_IS_REQUIRED: 'This field is required',
            THIS_FIELD_MUST_BE_A_VALID_EMAIL: 'This field must be a valid email',
            THIS_FIELD_CONFIRMATION_DOES_NOT_MATCH: 'This field confirmation does not match',
            VALID_KVK_NUMBER: 'Please use a valid KVK number',
            SELECT_KVK_COMPANY: 'Please select a company from the search results',
            VALID_URL: 'Please use a valid url',
            MIN_LENGTH_AMOUNT: 'The length needs to be at least {length} characters',
            MAX_LENGTH_AMOUNT: 'The length needs to be more than {length} characters',
            DATE_SELECT: 'Please select a date',
            SELECT_DIRECTORS: 'Please select the director(s)',
            NO_ZERO: 'Cannot be zero',
            POSITIVE_PRICE: 'The total amount has to a valid and positive amount',
            MAX_AMOUNT: 'The value has a maximum of {value}',
            MIN_AMOUNT: 'The value needs minimum of {value}',
            VALID_CURRENCY: 'Use valid currency format',
            ONLY_NUMBERS: 'Only numbers',
            NOT_POSSIBLE: 'Unfortunately, this is not possible.',
            VALID_ZIPCODE: 'Please use valid zipcode',
            PLEASE_FILL_ALL_FIELDS: 'Please fill all fields',
            PLEASE_FILL_TEXT: 'Please fill text',
            CHECK_ERROR: 'Click here to see the errors',
            FILE_HAS_NO_CONTENT: 'The selected file `{name}` has no content, please select another file.',
            CORRECT_AGE: 'You must be between 18 and 70 years old to continue.',
            VALID_PHONE_NUMBER: 'Please use a valid phone number',
            VALID_IBAN: 'Please use a valid IBAN number',
            NO_FILE_SELECTED: 'No file selected',
            VAT: 'Please use a valid VAT number',
        },
        FIELDS: {
            required: 'required',
        },
        SIGNING: {
            VIEWED: 'Viewed',
            SIGNED: 'Signed',
            DECLINED: 'Declined',
        },
        DOCUMENTS: {
            DOCUMENTS: 'Documents',
            NEW_DOCUMENT: 'New document',
            MANAGE_EMPLOYEES: 'Manage employees',
            MANAGE_PRIVACY: 'Manage privacy',
            SHAREHOLDERS_MANAGEMENT: 'Shareholders & management',
            ENGLISH_CONTRACTS: 'English contracts',
            CREATE: 'Create',
            DOCUMENT_NAME: 'Document name',
            NEW_CONTRACT: 'New contract',
            UPLOAD_CONTRACT: 'Upload contract',
            IT_AND_SOFTWARE: 'IT and software',
            ADVISOR_TOOLS: 'Advisor tools',
        },
        PAYMENT: {
            NEW_TITLE: 'New transaction',
            NEW_DESCRIPTION: 'New transaction description',
            STARTED_TITLE: 'Started transaction',
            STARTED_DESCRIPTION: 'Started transaction description',
            SUCCESSFUL_TITLE: 'Successful transaction',
            SUCCESSFUL_DESCRIPTION: 'Successful transaction description',
            CANCELED_TITLE: 'Canceled transaction',
            CANCELED_DESCRIPTION: 'Canceled transaction description',
            FAILED_TITLE: 'Failed transaction',
            FAILED_DESCRIPTION: 'Failed transaction description',
            ADVISOR: {
                SUCCESS_TITLE: 'Thanks for your payment!',
                SUCCESS_DESCRIPTION: 'We will contact you if necessary.',
                FAILED_TITLE: 'Payment has failed or is cancelled',
                FAILED_DESCRIPTION: 'Please try again or contract your bookkeeper',
                COMPLETE_DATA: 'Please complete your data',
                COMPANY_INFO: 'Company info',
            },
            PROOF_PAYMENT_DESCRIPTION: 'Upload a proof of the payment of the shares.',
        },
        SCENARIOS: {
            INCORPORATION_BV: 'Incorporate BV',
            UPSELL_HOLDING: 'Incorporate personal holding',
            CONVERT_BV: 'Incorporate to BV via asset transaction',
            TRANSFER_BV: 'Incorporate BV with deed of transfer',
            TRANSFER_BV_UPSELL: 'Incorporate holding with deed of transfer',
            TRANSFER_UPSELL_HOLDING: 'Incorporate holding with deed of transfer',
            LIQUIDATION_BV: 'Liquidation BV',
            UBO_REGISTRATION: 'Ubo registration (main)',
            UBO_REGISTRATION_SUB: 'Ubo registration (sub)',
            GENERAL_WORKFLOW: 'General workflow',
            FOUNDATION: 'Foundation',
        },
        DASHBOARD: {
            SUGGESTED_SERVICE: {
                HEADING: 'Suggested service',
                TITLE: 'Incorporate your BV',
                INTRO: 'Set up your BV from start to finish from home. Quickly and easily online in 3 steps.',
                POINT_1: '100% online',
                POINT_2: 'Always available',
                CTA_1: 'Get started',
                CTA_2: 'Learn more',
            },
        },
    },
    NL: {
        GLOBAL: {
            RECOMMENDED: 'Aanbevolen',
            CONTINUE: 'Volgende',
            COMPLETED: 'Voltooid',
            APPROVED: 'Goedgekeurd',
            SERVICE_PROVIDERS: 'Dienstenverleners',
            NO_RETAINER: 'Geen voorschot',
            CONTRACTS: 'Contracten',
            TEMPLATES: 'Templates',
            ALL: 'Alles',
            START_NEW_JOB: 'Start nieuwe job',
            DASHBOARD: 'Dashboard',
            SHORTCUT_TO: 'Snelkoppeling naar',
            JOBS: 'Jobs',
            RISK_WORDS: 'Risco woorden',
            IN_USE: 'In gebruik',
            THIS_YEAR: 'Dit jaar',
            CURRENT_YEAR: 'Huidige jaar',
            CURRENT_MONTH: 'Huidige maand',
            TOTAL_NUMBER: 'Totaal aantal',
            LANGUAGE: 'Taal',
            ENTITY: 'Entiteit',
            ENTITIES: 'Entiteiten',
            INVOICES: 'Facturen',
            APPLICATIONS: 'Applicaties',
            RUNNING_JOBS: 'Lopende jobs',
            COMPLETED_JOBS: 'Voltooide jobs',
            FIRM24: 'FIRM24',
            MANDATORY: 'Verplicht',
            OPTIONAL: 'Optioneel',
            REQUEST_UBO_REGISTRATION: 'Aangevraagde UBO-registratie',
            REJECT_JOB: 'Wijs de job af',
            REASON_REJECT_THE_JOB: 'Geef de dienstverlener een reden voor de afwijzing.',
            PAYMENT: 'Betaling',
            PAY_VALUE: 'Betaal {value}',
            CONTINUE_TO_PAYMENT: 'Doorgaan naar betaling',
            EXTRA_PAYMENT: 'Extra betaling',
            FIXED_FEE: 'Vaste prijs',
            QUOTE: 'Offerte',
            DATE: 'Datum',
            TIME: 'Tijd',
            FROM: 'Van',
            UNTIL: 'Tot',
            MISSING_DOCUMENT: 'Ontbrekend document',
            PRODUCT: 'Product',
            REPLACE: 'Vervangen',
            DELETE: 'Verwijderen',
            PREVIEW: 'Voorbeeld',
            TITLE: 'Titel',
            SLUG: 'Slug',
            RECURRENCE: 'Recurrence',
            CONTENT: 'Content',
            DOCUMENT: 'Document',
            DIRECTOR: 'Bestuurder',
            SHAREHOLDER: 'Aandeelhouder',
            FUNCTION: 'Functie',
            BV: 'BV',
            FOUNDATION: 'Stichting',
            TRUE: 'Ja',
            FALSE: 'Nee',
            CONFIRM: 'Bevestigen',
            ALERT: 'Alert',
            INFORM: 'Informeer',
            TYPE: 'Type',
            NO_DOCUMENTS_AVAILABLE: 'Geen documenten beschikbaar',
            NO_DATA_AVAILABLE: 'Geen data beschikbaar',
            NO_MESSAGE_AVAILABLE: 'Nog geen berichten.',
            NO_DESCRIPTION_AVAILABLE: 'Nog geen beschrijving.',
            LABEL: 'Label',
            STARTING_DATE: 'Ingangsdatum',
            LOGOUT: 'Uitloggen',
            NEXT_BILLING: 'Volgende factuurdatum',
            NOT_YET_AVAILABLE: 'N.t.b',
            NETHERLANDS: 'Nederlands',
            DUTCH: 'Nederlands',
            ENGLISH: 'Engels',
            PAGE_NOT_FOUND: 'Oeps, deze pagina kan niet gevonden worden',
            MODULES: 'Modules',
            ROLE: 'Rol',
            PERMISSIONS: 'Rechten',
            ITEMS_PER_PAGE: 'Artikelen per pagina',
            SEND_MESSAGE: 'Verstuur bericht [Ctrl+Enter]',
            ADD_ORGANIZATION: 'Organisatie toevoegen',
            NEW_MESSAGE: 'Nieuw bericht toevoegen',
            MESSAGES: 'Berichten',
            SKIP: 'Overslaan',
            TIMELINE: 'Tijdlijn',
            DOWNLOAD: 'Downloaden',
            DOWNLOAD_PDF: 'Download PDF',
            DOWNLOAD_FILE: 'Download bestand',
            DOWNLOAD_FILES: 'Download Bestanden',
            LAST_UPDATE: 'Laatste wijziging',
            CREATED: 'Aangemaakt',
            UPDATE: 'Bijwerken',
            UPDATED: 'Gewijzigd',
            AMOUNT: 'Bedrag',
            LAST_LOGIN: 'Laatste login',
            PRODUCTS: 'Producten',
            RISK_LEVEL: 'Risico niveau',
            CATEGORY: 'Categorie',
            ARE_YOU_SURE: 'Weet je het zeker?',
            ARE_YOU_SURE_UPLOAD_FILES: 'Weet u zeker dat u wilt uploaden {files}',
            ARE_YOU_SURE_GO_BACK: 'Weet u zeker dat u terug wilt gaan naar {step}?',
            ARE_YOU_SURE_TO: 'Weet u zeker dat u: {step}?',
            ARE_YOU_SURE_DELETE: 'Weet je zeker dat je dit item wilt verwijderen?',
            ARE_YOU_SURE_SKIP_STEP: 'Weet u zeker dat u deze stap wilt overslaan?',
            AGREE: 'Akkoord',
            CANCEL: 'Annuleer',
            CANCELLED: 'Geannuleerd',
            SAVE: 'Opslaan',
            DUPLICATE: 'Dupliceren',
            MALE: 'Dhr',
            FEMALE: 'Mw',
            SALUTATION: 'Aanhef',
            NEXT: 'Volgende',
            PREVIOUS: 'Vorige',
            CURRENT: 'Actueel',
            CLOSE: 'Sluiten',
            REMOVE: 'Verwijder',
            CREATE: 'Aanmaken',
            ADDRESS: 'Adres',
            INCLUDED: 'Inbegrepen',
            OPTIONS: 'Opties',
            MEMBER: 'Lid',
            MEMBERS: 'Leden',
            ADD_MEMBER: 'Lid toevoegen',
            UPLOAD: 'Uploaden',
            UPLOADED: 'Geüpload',
            SUBMIT: 'Verstuur',
            INFORMATION_BV: 'Informatie {entity}',
            ADDITIONAL_INFORMATION: 'Aanvullende BV informatie',
            SUBJECT: 'Onderwerp',
            DETAILS: 'Details',
            OVERVIEW: 'Overzicht',
            ATTACHMENT: 'Bijlage',
            CLEAR_ALL_NOTIFICATIONS: 'Wis alle meldingen',
            REMOVE_FILTERS: 'Verwijder filters',
            SEARCH: 'Zoeken...',
            REQUESTER: 'Aanvrager',
            PRICE: 'Prijs',
            SALE_PRICE: 'Verkoop prijs',
            PURCHASE_PRICE: 'Inkoop prijs',
            PURCHASE_TYPE: 'Inkoop type',
            DESCRIPTION: 'Omschrijving',
            REASON: 'Reden',
            URGENCY: 'Urgentie',
            REFRESH: 'Vernieuwen',
            CHAT_CLIENT: 'Chat met de klant',
            NOTARY: 'Notaris',
            ACCOUNT: 'Account',
            SUPPORT: 'FIRM24',
            CHAT: 'Chat met {group}',
            FAST: 'Snel',
            FAST_END_OF_THE_YEAR: 'Voor 1 januari',
            URGENT: 'Spoed',
            URGENT_END_OF_THE_YEAR: '5 werkdagen',
            REGULAR: 'Normaal',
            REGULAR_END_OF_THE_YEAR: 'Na 1 januari',
            DURATION: 'Tijd',
            HOLDING: 'Holding',
            SKIP_PAYMENT: 'Betaling overslaan',
            VIEW_INVOICE: 'Bekijk factuur',
            VIEW_X_INVOICE: 'Bekijk factuur {name}',
            RATING: 'Beoordeling',
            CLICK_HERE: 'Klik hier',
            CONNECT_WITH: {
                DEFAULT: 'Meld je aan met:',
                WITH_OR: 'Of meld je aan met:',
            },
            OR: 'of',
            RESET: 'Reset alle wijzigingen',
            SCENARIO: 'Scenario',
            SCENARIO_TYPE: 'Scenario type',
            STATUS: 'Status',
            STATUS_TERMINATED: 'Beëindigd',
            STATUS_PAUSED: 'Gepauzeerd',
            CONTINUE_APPLICATION: 'Voltooi aanvraag',
            ACTIONS: 'Acties',
            CHANGE: 'Wijzig',
            FULLY_PAID_SHARES: 'Aandelen volstorten',
            MORE_INFO: 'Meer info',
            NEXT_STEP: 'Volgende stap',
            DISTANCE: 'Afstand (kilometer)',
            TOTAL_PRICE: 'Totale Prijs',
            PSEUDO_UBO: 'Pseudo Ubo',
            ADD: 'Toevoegen',
            QUANTITY: 'Hoeveelheid',
            BATCHES: 'Batches',
            DELETE_PAYOUT: 'Uitbetaling verwijderen',
            TOTAL: 'Totaal',
            IBAN: 'IBAN',
            VAT: 'BTW',
            VAT_ADDED: 'BTW (21%)',
            PROCESSING_CAPACITY: 'Verwerkingscapaciteit',
            ACCOUNT_MANAGER: 'Account manager',
            SUBTOTAL: 'Subtotaal',
            LOADING: 'Loading...',
            RESULTS: 'Resultaten',
            NO_RESULTS: 'Geen resultaten',
            TIME_OPTIONS: {
                MORNING: 'Ochtend (09:00 - 12:00)',
                AFTERNOON: 'Middag (12:00 - 15:00)',
                LATE_AFTERNOON: 'Laat in de middag (15:00 - 18:00)',
                EVENING: 'Avond (18:00 - 20:00)',
            },
            OTHERS: 'Anderen',
            CANCEL_ADDING: 'Stop toevoegen',
            ADD_NEW_ONE: 'Nog een toevoegen',
            APPROVE: 'Goedkeuren',
            REJECT: 'Afwijzen',
            DECLINE: 'Afwijzen',
            CONFIRM_CANCELLATION: 'Bevestig annulering',
            ACCEPT: 'Accepteren',
            VAT_NUMBER: 'Vat nummer',
            CALENDLY: 'Calendly url',
            COMPLETE_JOB: 'Job afronden',
            CLIENT: 'Cliënt',
            BUSINESS: 'Bedrijf',
            VERSION: 'versie',
            FOUNDER: 'oprichter',
            EDIT: 'Bewerk',
            PAY: 'Betalen',
            SERVICE_PROVIDER: 'Dienstverlener',
            TERMS_CONDITIONS_FILE_NAME: 'Algemene Voorwaarden',
            UPLOAD_TERMS_CONDITIONS: 'Algemene voorwaarden uploaden',
            LOGO: 'Logo',
            NAME: 'Naam',
            EMAIL: 'E-mail',
            COMMENTS: 'Opmerkingen van klanten',
            NO_COMMENTS: 'Geen reacties',
            INVITE_CUSTOMER: 'Klant uitnodigen',
            FREE: 'GRATIS',
            RETAINER: 'Voorschot',
            CURRENT_ACTOR: 'Actor aan zet',
            SCHEDULE_INTERVIEW: 'Maak een afspraak',
            STEP: 'Stap',
            PROCESS: 'Proces',
            MISSING_NAME: 'Geen naam',
            MILESTONE: 'Milestone',
            CREDIT: 'Creditering',
            HOURS: 'uur',
            CHOOSE_FILE: 'Kies bestand',
            REFERENCE: 'Referentie',
            YES: 'Ja',
            NO: 'Nee',
            PROCESS_LABELS: 'Proces labels',
            NO_DATA: 'Geen data',
            UPLOAD_PLACEHOLDER: 'Sleep de PDF documenten of klik om te uploaden',
        },
        NAVIGATION: {
            MY_PRODUCTS: 'Mijn producten',
            COMPANY_DETAILS: 'Bedrijfsgegevens',
            PRODUCTS_AND_SERVICES: 'Producten & diensten',
            SHOP_DEALS: 'Ondernemersdeals',
            EMAILS: 'Emails',
            SUBSCRIPTIONS: 'Abonnementen',
            DASHBOARD: 'Dashboard',
            ORGANIZATIONS: 'Organisaties',
            ORGANIZATION: 'Organisatie',
            ACCOUNTS: 'Accounts',
            ACCOUNT: 'Account',
            OVERVIEW: 'Overzicht',
            PROCESSES: 'Processen',
            STATS: 'Stats',
            ACCOUNT_TRANSACTIONS: 'Account Transacties',
            BOOKKEEPER_TRANSACTIONS: 'Boekhouder Transacties',
            BOOKKEEPER_LEADS: 'Boekhouder Leads',
            BOOKKEEPING: 'Boekhouding',
            SERVICES: 'Diensten',
            TRANSACTIONS: 'Transacties',
            PURCHASE: 'Inkoop transacties',
            PAYOUT: 'Uitbetalingen',
            PAYOUT_BATCH: 'Uitbetaling batches',
            SALES: 'Verkoop transacties',
            SALE: 'Sales',
            INVOICES: 'Facturen',
            BANKING: 'Bankieren',
            PURCHASE_PAYOUT: 'Uitbetaling',
            CREDIT: 'Credit transacties',
            ADD_PRODUCT_TO_PAYOUT: 'Product toevoegen aan uitbetaling',
            LEADS: 'Leads',
            LOGIN: 'inloggen',
            PROCEDURES: 'Procedures',
            NEW_PROCEDURES: 'Nieuwe procedures',
            CONTRACTS: 'Contracten',
            REQUESTED_SERVICES: 'Aangevraagde diensten',
            REQUEST_A_SERVICE: 'Vraag een dienst aan',
            BILLING: 'Facturen',
            UBO: 'UBO registratie',
            LIQUIDATION: 'Bedrijf opheffen',
            OTHER_SERVICES: 'Andere diensten',
            DGA_SERVICES: 'Salaris administratie',
            DGA_SALARY_ADMIN: 'DGA Salarisadministratie',
            SEARCH_SERVICE: 'Zoeken',
            INCORPORATION_BV: 'Oprichten',
            MODIFY_BV: 'Wijzig je BV',
            ACCOUNTING: 'Boekhouding & Belastingen',
            FINANCES: 'Bankieren',
            COMPLIANCE: 'Contracten & Regelgeving',
            SPECIALIST: 'Krijg deskundig advies',
            ACCOUNT_SETTINGS: 'Instellingen',
            TASKS: 'Taken',
            ADMIN: 'Admin',
            HOSTING: 'Hosting',
            ZEBRA_LEGAL: 'Zebra Legal',
            PAYMENT_SOLUTIONS: 'Betalingsoplossingen',
        },
        USER: {
            NAME: 'Naam',
            EMAIL: 'E-mailadres',
            FIRST_NAME: 'Voornaam',
            LAST_NAME: 'Achternaam',
            COMPANY_LOCATION: 'Land waar uw bedrijf is gevestigd',
            FIRST_LAST_NAME: 'First and last name',
            BIRTH_DATE: 'Geboortedatum',
            BIRTH_COUNTRY: 'Geboorteland',
            BIRTH_PLACE: 'Geboorteplaats',
            NATIONALITY: 'Nationaliteit',
            LANGUAGE: 'Taal',
            SPEAKS_DUTCH: 'Spreekt Nederlands',
            SPEAKS_ENGLISH: 'Spreekt Engels',
            SELECT_OPTION: 'Kies een optie',
            SELECT_EXPIRATION_DATE: 'Kies een vervaldatum',
            SELECT_DATE: 'Kies een datum',
            FILL_IN: 'Vul de gegevens in',
            GENDER: 'Geslacht',
            PHONE: 'Telefoonnummer',
            CONTACT: 'Contactpersoon',
            SIGN_IN: 'Aanmelden',
            FORGOT_PASSWORD: 'Wachtwoord vergeten?',
            RESET_PASSWORD: 'Wachtwoord resetten',
            REGISTER: 'Registreren',
            CREATE_YOUR_ACCOUNT: 'Aanmelden',
            INITIALS: 'Voorletter(s)',
            ENTREPRENEUR_DMS: 'Ondernemer (DGA)',
            ENTREPRENEUR_DMS_DESCRIPTION:
                'Kies voor ondernemer als je de aanvraag voor een eigen onderneming doet. Dit kan een BV zijn maar ook een eenmanszaak, VOF of andere rechtsvorm.',
            ADVISOR: 'Adviseur',
            ADVISOR_DESCRIPTION:
                'Kies voor adviseur wanneer je de aanvraag doet voor je cliënten. Je bent bijv. een boekhouder, accountant of andere bedrijfsadviseur.',
            EXISTING_CLIENT: 'Ik ben al klant',
        },
        ADDRESS: {
            STREET: 'Straat',
            POSTAL_CODE: 'Postcode',
            POSTALCODE: 'Postcode',
            NUMBER: 'Huisnummer',
            ADDITION: 'Toevoeging',
            CITY: 'Plaatsnaam',
            PROVINCE: 'Woonland',
            COUNTRY: 'Land',
            PLACE_RESIDENCY: 'Woonplaats',
            COUNTRY_RESIDENCY: 'Woonland',
            NAME: 'Naam',
        },
        VALIDATION: {
            THIS_FIELD_IS_REQUIRED: 'Dit veld is verplicht',
            THIS_FIELD_MUST_BE_A_VALID_EMAIL: 'Dit veld moet een geldig e-mailadres bevatten',
            THIS_FIELD_CONFIRMATION_DOES_NOT_MATCH: 'Deze velden komen niet overeen',
            VALID_KVK_NUMBER: 'Gebruik een geldig KVK-nummer',
            SELECT_KVK_COMPANY: 'Selecteer een bedrijf uit de zoekresultaten',
            MIN_LENGTH_AMOUNT: 'De lengte moet minimaal {length} tekens zijn',
            MAX_LENGTH_AMOUNT: 'De lengte moet langer dan {length} tekens zijn',
            MAX_AMOUNT: 'De waarde heeft een maximum van {value}',
            MIN_AMOUNT: 'De waarde heeft een minimum van {value}',
            DATE_SELECT: 'Selecteer een datum',
            SELECT_DIRECTORS: 'Selecteer de bestuurder(s)',
            NO_ZERO: 'Mag niet nul zijn',
            POSITIVE_PRICE: 'Het total bedrag dient een geldig en positief bedrag te zijn',
            VALID_CURRENCY: 'Gebruik geldige valutanotatie',
            ONLY_NUMBERS: 'Alleen nummers',
            NOT_POSSIBLE: 'Dit is helaas niet mogelijk.',
            VALID_ZIPCODE: 'Gebruik een geldige postcode',
            PLEASE_FILL_ALL_FIELDS: 'Vul alle velden in',
            PLEASE_FILL_TEXT: 'Vul de tekst in',
            CHECK_ERROR: 'Klik hier om de fouten te zien',
            FILE_HAS_NO_CONTENT: 'Het geselecteerde bestand `{name}` heeft geen inhoud, selecteer een ander bestand.',
            CORRECT_AGE: 'Je moet tussen de 18 en 70 jaar oud zijn om door te gaan.',
            VALID_PHONE_NUMBER: 'Gebruik een geldig telefoonnummer',
            VALID_IBAN: 'Gebruik een geldig IBAN-nummer',
            NO_FILE_SELECTED: 'Geen bestand geselecteerd',
            VAT: 'Gebruik een geldig btw-nummer',
        },
        SIGNING: {
            VIEWED: 'Bekeken',
            SIGNED: 'Ondertekend',
            DECLINED: 'Afgewezen',
        },
        DOCUMENTS: {
            NEW_DOCUMENT: 'Nieuw document',
            MANAGE_EMPLOYEES: 'Werknemers & freelancers',
            MANAGE_PRIVACY: 'Privacy & geheimhouding',
            SHAREHOLDERS_MANAGEMENT: 'Aandeelhouders & management',
            ENGLISH_CONTRACTS: 'Engelse contracten',
            CREATE: 'Aanmaken',
            DOCUMENT_NAME: 'Document Naam',
            NEW_CONTRACT: 'Nieuw contract',
            UPLOAD_CONTRACT: 'Contract uploaden',
            DOCUMENTS: 'Bestanden',
            IT_AND_SOFTWARE: 'IT en software',
            ADVISOR_TOOLS: 'Adviseurstools',
        },
        PAYMENT: {
            NEW_TITLE: 'Nieuwe betaling',
            NEW_DESCRIPTION: 'New transaction description',
            STARTED_TITLE: 'Start nieuwe betaling',
            STARTED_DESCRIPTION: 'Started transaction description',
            SUCCESSFUL_TITLE: 'Succesvolle betaling',
            SUCCESSFUL_DESCRIPTION: 'Successful transaction description',
            CANCELLED_TITLE: 'Canceled transaction',
            CANCELLED_DESCRIPTION: 'Canceled transaction description',
            FAILED_TITLE: 'Failed transaction',
            FAILED_DESCRIPTION: 'Failed transaction description',
            ADVISOR: {
                SUCCESS_TITLE: 'Bedankt voor uw betaling!',
                SUCCESS_DESCRIPTION: 'We zullen contact met u opnemen indien nodig.',
                FAILED_TITLE: 'Betaling is gefaald of afgebroken',
                FAILED_DESCRIPTION: 'Probeer het opnieuw of neem contact op met uw boekhouder',
                COMPLETE_DATA: 'Gelieve uw gegevens in te vullen',
                COMPANY_INFO: 'Bedrijfsgegevens',
            },
            PROOF_PAYMENT_DESCRIPTION: 'Upload een bewijs van het volstorten van de aandelen.',
        },
        SCENARIOS: {
            INCORPORATION_BV: 'Oprichting BV',
            UPSELL_HOLDING: 'Oprichting holding',
            CONVERT_BV: 'Oprichting BV via activa-passiva transactie',
            TRANSFER_BV: 'Oprichting BV met inbrengakte',
            TRANSFER_BV_UPSELL: 'Oprichting holding met inbrengakte',
            TRANSFER_UPSELL_HOLDING: 'Oprichting holding met inbrengakte',
            LIQUIDATION_BV: 'Opheffing BV',
            UBO_REGISTRATION: 'Ubo registration (hoofd)',
            UBO_REGISTRATION_SUB: 'Ubo registration (sub)',
            GENERAL_WORKFLOW: 'General workflow',
            FOUNDATION: 'Stichting',
        },
        DASHBOARD: {
            SUGGESTED_SERVICE: {
                HEADING: 'Aangeraden diensten',
                TITLE: 'Richt je BV op',
                INTRO: 'Vanuit je huis je BV oprichten van het begin tot eind. Snel en gemakkelijk online in 3 stappen.',
                POINT_1: '100% online',
                POINT_2: 'Altijd beschikbaar',
                CTA_1: 'Starten',
                CTA_2: 'Lees meer',
            },
        },
    },
};
